import React from "react"
import { Box, Chip } from "@mui/material"
import "./styles.css"

const GroupBadge = ({ label, isEnterprise = false, className = "", ...props }) => (
    <Box
        className={`kwik-group-badge ${isEnterprise ? "kwik-group-badge-enterprise" : ""} ${className}`.trim()}
        {...props}
    >
        {label}
    </Box>
)

export const GroupChip = ({ isEnterprise = false, className = "", ...props }) => (
    <Chip
        {...props}
        className={`kwik-group-chip ${isEnterprise ? "kwik-group-chip-enterprise" : "kwik-group-chip-contact"} ${className}`.trim()}
    />
)

export default GroupBadge